import { checkDateIfSame, getCropUrl, parseFloatingDate } from "../../../Helpers/utils";
import { ImageModel } from "../../../models/ImageModel";
import { TileModel } from "../../models/TileModel";
import { format } from 'date-fns';

export default function EventTile({ node, defaultImage }: TileModel) {
  const image = node.properties['image'] as ImageModel ?? null;
  const imageUrl = image ? getCropUrl(image, 'tile') : (defaultImage ?? '');

  // Event dates are floating wall-clock values (see parseFloatingDate); formatting
  // them in a fixed timezone shifted every time by the visitor's offset.
  const startDate = parseFloatingDate(node.properties["dateStart"]);
  const endDate = parseFloatingDate(node.properties["dateEnd"]);
  const sameDate = startDate && endDate ? checkDateIfSame(startDate, endDate) : true;

  return (
    <div className="cell event-wrapper">
      <div className="thumbnail">
          <a href={node.url}>
              <img src={imageUrl} alt={node.name} />
              <div className="caption">
                  <div className="date">
                      <span>
                          {startDate && format(startDate, 'MMM')}
                          <label>{startDate && format(startDate, 'dd')}</label>
                      </span>
                  </div>
                  <div className="event-info">
                      <h6>{node.name}</h6>
                      <ul>
                          { (!sameDate && startDate && endDate) &&
                          <>
                            <li>
                              <span>Date:</span><span>{format(startDate, 'MMM dd')} - {format(endDate, 'MMM dd')}</span>
                            </li>
                            <li>
                              <span>Time:</span><span>{format(startDate, 'hh:mma')} - {format(endDate, 'hh:mma')}</span>
                            </li>
                          </>
                          }
                          { (sameDate && startDate) &&
                            <li>
                                <span>Time:</span><span>{format(startDate, 'hh:mma')}</span>
                            </li>
                          }

                          <li><span>Location:</span><span> {node.properties['location']}</span></li>
                      </ul>
                      <span className="go"><i className="fa fa-angle-right"></i></span>
                  </div>
              </div>
          </a>
        </div>
    </div>
  )
}
